import {
	ADMINADDORUPDATEFEE_SUCCESS,
	ADMINADDORUPDATEFEE_FAILED,
	RESET_ADMINADDORUPDATEFEE,
	LOADING_ADMINADDORUPDATEFEE,
	NETWORK_ERROR_ADMINADDORUPDATEFEE
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminAddOrUpdateFee = () => {
	return { type: RESET_ADMINADDORUPDATEFEE };
};

const adminAddOrUpdateFee = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINADDORUPDATEFEE });
	await adminServices
		.post("addOrUpdateFee", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminAddOrUpdateFeesuccess(res.data));
					break;
				default:
					dispatch(adminAddOrUpdateFeeFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINADDORUPDATEFEE,
				payload: err
			});
		});
};
function adminAddOrUpdateFeesuccess(data) {
	return {
		type: ADMINADDORUPDATEFEE_SUCCESS,
		payload: data
	};
}
function adminAddOrUpdateFeeFailed(data) {
	return {
		type: ADMINADDORUPDATEFEE_FAILED,
		payload: data
	};
}

export { resetAdminAddOrUpdateFee, adminAddOrUpdateFee };
